// serviceWorkerRegistration.js
// Sistema de detecção e atualização automática de versão

import packageJson from '../package.json';

// Fonte única da versão: package.json (embutido no build pelo webpack). Antes era
// um número hardcoded aqui, que vivia defasado dos outros arquivos — bastava
// esquecer de atualizar um deles para o mecanismo de update sair de sincronia.
const APP_VERSION = packageJson.version;

// Função para verificar se há nova versão disponível
const checkForUpdates = async () => {
  try {
    // Busca o index.html com cache desabilitado
    const response = await fetch('/index.html', {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      }
    });
    
    await response.text(); // consome o corpo da resposta

    // Verifica se a versão mudou (você pode adicionar uma meta tag com a versão)
    // Por enquanto, apenas força reload se houver service worker updates
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration && registration.waiting) {
        // Há um service worker esperando, force a atualização
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
        return true;
      }
    }
    
    return false;
  } catch (error) {
    console.error('Erro ao verificar atualizações:', error);
    return false;
  }
};

// Configuração do service worker
export function register(config) {
  if ('serviceWorker' in navigator) {
    // Aguarda o load para não interferir no carregamento inicial
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      registerValidSW(swUrl, config);

      // Verifica por atualizações a cada 30 minutos
      setInterval(() => {
        checkForUpdates();
      }, 30 * 60 * 1000); // 30 minutos
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[App] Service Worker registrado com sucesso. Versão:', APP_VERSION);

      // Verifica por atualizações quando a aba fica visível
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update();
        }
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nova versão disponível!
              console.log('[App] Nova versão disponível! Atualizando...');

              // Notifica o usuário (opcional, pode remover para atualização silenciosa)
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Força a atualização automaticamente após 3 segundos
              setTimeout(() => {
                installingWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }, 3000);
            } else {
              // Primeira instalação
              console.log('[App] Conteúdo cacheado para uso offline.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[App] Erro ao registrar service worker:', error);
    });
}

// Função para desregistrar o service worker (caso necessário)
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Função para limpar todo o cache manualmente
export function clearAllCache() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        registration.active.postMessage({ type: 'CLEAR_CACHE' });
      }
    });
  }
  
  // Também limpa o cache do navegador
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
  
  console.log('[App] Cache limpo. Recarregando...');
  setTimeout(() => window.location.reload(true), 1000);
}

// Exporta a versão atual
export { APP_VERSION };
